import moment from 'moment'
import { convert1DArrayTo2DArray } from '../helpers/convert1DArrayTo2DArray'
import { LocationParams } from './school-api'
import { TeacherEmploymentSetting } from '../redux/types'
import { logger } from '../helpers/logger'

interface IBatchRequests<T> {
    asyncFuncs: (() => Promise<T>)[]
    count: number
    errorMsg: string
}

// Used for Large amount requests, becuase browser has limition on simoutaneous request
export const batchRequests = async <T>({
    asyncFuncs,
    count,
    errorMsg,
}: IBatchRequests<T>) => {
    try {
        const async2DFuncs = convert1DArrayTo2DArray(asyncFuncs, count)
        const res = await Promise.all(
            async2DFuncs.map((asyncFuncs) =>
                Promise.all(asyncFuncs.map((asyncFunc) => asyncFunc()))
            )
        )

        return { code: 200, value: res.flat() }
    } catch (error) {
        logger.error(`Errors happen when trying to ${errorMsg}.`)
        logger.error(error)
        return { code: 500 }
    }
}

export const getUserStoragePath = (id: string) =>
    `/${id}/public/profilePicture_${moment().format('DD-MM-YYYY-HH:mm:ss')}`
export const getUserDocStoragePath = (id: string, name: string) =>
    `/${id}/private/${name}`
export const getReferenceStoragePath = (id: string) => `/references/${id}`

// Callable Function type
export type CallableFunctionResponse<T> = {
    success: true
} & T

const getBookablePath = (
    interest: TeacherEmploymentSetting,
    queryType: 'date' | 'teacherUid'
) => {
    switch (interest) {
        case 'school': {
            return queryType === 'date'
                ? 'availableTeachers'
                : 'bookableTeacherAvailability'
        }
        case 'supportStaff': {
            return queryType === 'date'
                ? 'availableSupportStaffByDate'
                : 'availableSupportStaffByUUID'
        }
    }
}

export const DB_REF = {
    countriesRoot: (args: LocationParams) =>
        `countries/${args.country}/${args.locationState}`,
    schoolBookablePath: (
        args: LocationParams & {
            queryType: 'date' | 'teacherUid'
            interest: TeacherEmploymentSetting
            schoolUid: string
        }
    ) =>
        `${DB_REF.countriesRoot(args)}/schools/${getBookablePath(args.interest, args.queryType)}/${args.schoolUid}`,
} as const
